import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Col, Grid, Image, Row } from 'antd';
import { formatDateResultPregnancy } from 'src/utils/func/kalender-kehamilan';
import style from './style.module.less';
function DisclaimerResultHpl(props: any) {
  const {
    xs,
    sm,
    md
  } = Grid.useBreakpoint();
  const OS = isAndroid ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isWindows ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isMacOs ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : isIOS ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
  return <div className={style.cards}>
			<div className={style.disclaimer}>
				<div className="d-flex">
					<div className={style.disclaimer__left}>
						<Row>
							<Col xs={24} sm={24} md={16}>
								<div className={style.disclaimer__header}>
									<h5>Mima 👧</h5>
								</div>
								<p style={{
                fontSize: xs ? '12px' : '14px',
                padding: '5px',
                width: xs ? '90%' : '100%'
              }}>
									Selamat Ma! Perkiraan hari lahir si Kecil tanggal <span style={{
                  color: '#f36d6d',
                  fontWeight: 500
                }}>{formatDateResultPregnancy(props?.hpl_date)}</span>.
									Yuk, pantau perkembangan kehamilan setiap harinya dengan lebih mudah Download
									aplikasi Hallobumil sekarang untuk mendapatkan tips dan informasi menyambut kelahiran si Kecil dengan lebih siap! 👶️️️️❤️
								</p>
							</Col>
							<Col xs={24} sm={24} md={8}>
								{xs ? <div>
											<Image src="/images/default/logoPlayStore.svg" alt="image" style={{
                  width: sm ? 150 : xs ? 120 : md ? 120 : 150,
                  height: sm ? 38 : xs ? 25 : md ? 25 : 38,
                  cursor: 'pointer'
                }} preview={false} onClick={() => window.open(OS)} id="play-store" />
											<Image src="/images/default/logoAppStore.svg" alt="image" style={{
                  width: sm ? 150 : xs ? 120 : md ? 120 : 150,
                  height: sm ? 38 : xs ? 25 : md ? 25 : 38,
                  cursor: 'pointer',
                  marginLeft: '-20px'
                }} preview={false} onClick={() => window.open(OS)} id="app-store" />
										</div> : <Row style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}>
											<Col span={12} style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: xs ? 'right' : 'center'
                }}>
												<Image src="/images/default/logoPlayStore.svg" alt="image" style={{
                    width: sm ? 150 : xs ? 120 : md ? 120 : 150,
                    height: sm ? 38 : xs ? 25 : md ? 25 : 38,
                    cursor: 'pointer'
                  }} preview={false} onClick={() => window.open(OS)} id="play-store" />
											</Col>
											<Col span={12} style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: xs ? 'left' : 'center'
                }}>
												<Image src="/images/default/logoAppStore.svg" alt="image" style={{
                    width: sm ? 150 : xs ? 120 : md ? 120 : 150,
                    height: sm ? 38 : xs ? 25 : md ? 25 : 38,
                    cursor: 'pointer'
                  }} preview={false} onClick={() => window.open(OS)} id="app-store" />
											</Col>
										</Row>}
							</Col>
						</Row>
					</div>
				</div>
			</div>
			<p style={{
      fontSize: xs ? '12px' : '14px',
      margin: '10px'
    }}>Terimakasih Mima!❤️❤️</p>
		</div>;
}
export default DisclaimerResultHpl;